import { api, authHeader } from "../configs/axiosConfigs";

const baseBySource = (source) =>
  source === "Management"
    ? "/SLN/Management/FinancialCore"
    : "/SLN/SolarentOperator/FinancialCore";

const FinancialCoreApi = {
  getByRequestId: async (source, requestInfoId) => {
    const response = await api.request({
      url: `${baseBySource(source)}/GetByRequestId/${requestInfoId}`,
      method: "GET",
      headers: authHeader(),
    });
    return response.data;
  },

  recalculateProfile: async (source, requestInfoId) => {
    const response = await api.request({
      url: `${baseBySource(source)}/RecalculateProfile/${requestInfoId}`,
      method: "POST",
      headers: authHeader(),
    });
    return response.data;
  },

  getInvoiceIssuanceContext: async (source, requestInfoId) => {
    const response = await api.request({
      url: `${baseBySource(source)}/GetInvoiceIssuanceContext/${requestInfoId}`,
      method: "GET",
      headers: authHeader(),
    });
    return response.data;
  },

  getInvoicesByRequestId: async (source, requestInfoId) => {
    const response = await api.request({
      url: `${baseBySource(source)}/GetInvoicesByRequestId/${requestInfoId}`,
      method: "GET",
      headers: authHeader(),
    });
    return response.data;
  },

  getTransactionsByRequestId: async (source, requestInfoId) => {
    const response = await api.request({
      url: `${baseBySource(source)}/GetTransactionsByRequestId/${requestInfoId}`,
      method: "GET",
      headers: authHeader(),
    });
    return response.data;
  },

  createInvoice: async (source, data) => {
    const response = await api.request({
      url: `${baseBySource(source)}/CreateInvoice`,
      method: "POST",
      headers: authHeader(),
      data,
    });
    return response.data;
  },

  registerManualTransaction: async (source, data) => {
    const response = await api.request({
      url: `${baseBySource(source)}/RegisterManualTransaction`,
      method: "POST",
      headers: authHeader(),
      data,
    });
    return response.data;
  },

  registerLoanDisbursementTransaction: async (source, data) => {
    const response = await api.request({
      url: `${baseBySource(source)}/RegisterLoanDisbursementTransaction`,
      method: "POST",
      headers: authHeader(),
      data,
    });
    return response.data;
  },

  registerLoanDisbursementByRequestNumber: async (source, data) => {
    const response = await api.request({
      url: `${baseBySource(source)}/RegisterLoanDisbursementByRequestNumber`,
      method: "POST",
      headers: authHeader(),
      data,
    });
    return response.data;
  },

  /** ویرایش دستی مبلغ واریز — فقط مدیریت */
  updateRequestLoanDisbursement: async (source, data) => {
    const response = await api.request({
      url: `${baseBySource(source)}/UpdateRequestLoanDisbursement`,
      method: "POST",
      headers: authHeader(),
      data,
    });
    return response.data;
  },

  /**
   * لیست واریزهای ثبت‌شده وام + جمع کل و به تفکیک لندتک.
   */
  getLoanDisbursementsOverview: async (
    source,
    { partnerCode = "", search = "", take = 200 } = {}
  ) => {
    const params = new URLSearchParams();
    if (partnerCode) params.set("partnerCode", partnerCode);
    if (search) params.set("search", search);
    if (take) params.set("take", String(take));
    const qs = params.toString();
    const response = await api.request({
      url: `${baseBySource(source)}/GetLoanDisbursementsOverview${qs ? `?${qs}` : ""}`,
      method: "GET",
      headers: authHeader(),
    });
    return response.data;
  },

  /**
   * آپلود اکسل تفکیک واریز وام تجمیعی.
   * ستون‌ها: شماره درخواست، مبلغ واریزی، شماره سند
   * @param {File} file
   * @param {boolean} confirm false=پیش‌نمایش، true=اعمال
   * @param {string} partnerCode الزامی: IRIA_PAY | BARQ_PAY
   */
  importLoanDisbursementsExcel: async (
    source,
    file,
    confirm = false,
    partnerCode = ""
  ) => {
    if (!file) {
      throw new Error("فایل اکسل انتخاب نشده است.");
    }
    if (!partnerCode || !String(partnerCode).trim()) {
      throw new Error("انتخاب لندتک فایل الزامی است (IRIA_PAY یا BARQ_PAY).");
    }
    const formData = new FormData();
    formData.append("file", file, file.name || "loan-disbursements.xlsx");
    formData.append("confirm", confirm ? "true" : "false");
    formData.append("partnerCode", String(partnerCode).trim());

    const response = await api.request({
      url: `${baseBySource(source)}/ImportLoanDisbursementsExcel`,
      method: "POST",
      headers: authHeader(),
      data: formData,
    });
    return response.data;
  },

  syncLegacyProjectPayment: async (source, projectPaymentId) => {
    const response = await api.request({
      url: `${baseBySource(source)}/SyncLegacyProjectPayment/${projectPaymentId}`,
      method: "POST",
      headers: authHeader(),
    });
    return response.data;
  },

  approveTransaction: async (source, transactionId) => {
    const response = await api.request({
      url: `${baseBySource(source)}/ApproveTransaction/${transactionId}`,
      method: "POST",
      headers: authHeader(),
    });
    return response.data;
  },

  rejectTransaction: async (source, transactionId, data = {}) => {
    const response = await api.request({
      url: `${baseBySource(source)}/RejectTransaction/${transactionId}`,
      method: "POST",
      headers: authHeader(),
      data,
    });
    return response.data;
  },
};

export default FinancialCoreApi;
